import { render } from "./publication-distribution.vue?vue&type=template&id=32243a27"
import script from "./publication-distribution.vue?vue&type=script&lang=js"
export * from "./publication-distribution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__